<script setup lang="ts">
import { defineModel } from 'vue';

import Button from 'primevue/button';

import { useSelectViewItems } from '@/composables/useSelectViewItems';
import { useViewNavigation } from '@/composables/useViewNavigation';
import { useHiddenInputs } from '@/composables/useHiddenInputs';
import CalculationViewLink from '@/components/CalculationViewLink.vue';
import ItemProductInput from '../components/ItemProductInput.vue';
import ItemValueInput from '../components/ItemValueInput.vue';
import ItemRuleInput from '../components/ItemRuleInput.vue';
import ProductMaterials from '../components/ProductMaterials.vue';
import ProductOverview from '../components/ProductOverview.vue';

const { isHiddenInputs } = useHiddenInputs();
const { nextViewButton, prevViewButton } = useViewNavigation();

const selectedItems = defineModel<{ [key: string]: number | null }>('selectedItems', {
  type: Object,
  required: true,
});

const { handleNextView, isValid, isLoading, items, getItemProduct, getItemProductMaterials } =
  useSelectViewItems(selectedItems);
</script>

<template>
  <form v-auto-animate class="space-y-11" @submit.prevent="handleNextView">
    <div :key="item.id" v-for="item in items?.filter((item) => !item.is_hidden || !isHiddenInputs)">
      <template v-if="item.type === 'product'">
        <ItemProductInput v-model="selectedItems[item.id]" :item="item" />

        <ProductOverview :product="getItemProduct(item)" />

        <ProductMaterials :materials="getItemProductMaterials(item)" />
      </template>

      <template v-else-if="item.type === 'rule'">
        <ItemRuleInput :item="item" />
      </template>

      <ItemValueInput v-else v-model="selectedItems[item.id]" :item="item" />

      <div class="mt-2">
        <CalculationViewLink v-if="item.links.length > 0" :links="item.links" />
      </div>
    </div>

    <div class="flex justify-center gap-6">
      <!-- <RouterLink :to="prevViewButton.route">
        <Button class="font-semibold" severity="secondary" outlined size="small">
          {{ prevViewButton.title }}
        </Button>
      </RouterLink> -->

      <Button
        v-if="nextViewButton.title !== 'Podsumowanie'"
        type="submit"
        class="font-semibold"
        size="small"
        :disabled="!isValid || isLoading"
      >
        {{ nextViewButton.title }}
      </Button>
    </div>
  </form>
</template>
